export class PreRegistrationDetails {
  public VerificationEmailStatus?: VerificationEmailStatus;
  public VerificationOtpStatus?: VerificationOtpStatus;
  public VerificationOtpAttempts?: number;
  public VerificationOverallStatus?: PreRegistrationVerificationStatuses;
  public IDVerseVerificationStatus?: PreRegistrationVerificationStatuses;
  public CrossCoreVerificationResponse?: PreRegistrationVerificationResponses;
  public IDVerseVerificationResponse?: PreRegistrationVerificationResponses;
  public RegistrationEmailStatus?: RegistrationEmailStatus;
  public RegistrationOtpStatus?: RegistrationOtpStatus;
  public RegistrationOtpAttempts?: number;
  public MaximumAttemptsPerOTPCode?: number;
  public CrossCoreClientReferenceId?: string;
  public CrossCoreRBNumber?: string;
  public IDVerseClientReferenceId?: string;
  public IDVerseRBNumber?: string;
  public IsRegistrationVerification?: boolean;
}

export enum VerificationEmailStatus {
  Pending = 'pending',
  Completed = 'completed',
  Expired = 'expired'
}

export enum VerificationOtpStatus {
  Pending = 'pending',
  Completed = 'completed'
}

export enum CustomerVerificationStatus {
  InProgress = 'inprogress',
  Pass = 'pass',
  Failed = 'failed',
  NoDecision = 'nodecision'
}

export enum RegistrationEmailStatus {
  Pending = 'pending',
  Completed = 'completed',
  Expired = 'expired'
}

export enum RegistrationOtpStatus {
  Pending = 'pending',
  Completed = 'completed'
}

export enum PreRegistrationDetailsStageStatuses {
  Pending = 'pending',
  Completed = 'completed',
  Expired = 'expired',
  InProgress = 'inprogress',
  Pass = 'pass',
  Failed = 'failed',
  NoDecision = 'nodecision'
}

export enum PreRegistrationVerificationStatuses {
  Initiated = 'initiated',
  InProgress = 'inprogress',
  Successful = 'successful',
  Complete = 'complete',
  Unsuccessful = 'unsuccessful',
  Expired = 'expired',
  ExpiredWithTechnicalFailure = 'expiredWithTechnicalFailure'
}

export enum PreRegistrationVerificationResponses {
  Continue = 'continue',
  Refer = 'refer',
  NoDecision = 'nodecision',
  Bypassed = 'bypassed',
  Stop = 'stop'
}
